export function LabelInput(ev) {
  let textElm = ev.srcElement;
  if (textElm.value !== "" && !textElm.classList.contains("not-empty")) {
    textElm.classList.add("not-empty");
  } else if (textElm.value === "") {
    textElm.classList.remove("not-empty");
  }
}
